import React, { useState } from 'react'
import { withTheme } from 'theming'
import AddSection from '../addSection'
import EditMenu from '../editMenu'
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu'
import CustomImage from '../../customImage/customImage'
import useTemplateHook from '../templateHook'
import { isEmpty } from 'lodash'

const BreakingInsightsCarousel = ({
  componentData,
  modifyData,
  setModalState,
  isEdit,
  onSwap,
  onDelete,
  onCopy,
  theme,
  onAdd,
}) => {
  const { data, id } = componentData
  const { customNavigate, KalingoLeftArrow, KalingoRightArrow } = useTemplateHook()
  const [hoverState, setHoverState] = useState('')

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }
  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const handleHoverItems = (name) => {
    if (!isEdit) return
    setHoverState(name)
  }

  const handleRedirect = (linkObj) => {
    customNavigate('INDIRECT', linkObj, isEdit)
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey].data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  function LeftArrow() {
    const { isFirstItemVisible, scrollPrev } = React.useContext(VisibilityContext)
    return (
      <button
        className={`absolute left-0 z-10 bg-transparent px-0 hidden lg:flex justify-center ${
          isFirstItemVisible ? 'opacity-0' : 'opacity-100'
        }`}
        disabled={isFirstItemVisible}
        onClick={() => scrollPrev()}
        title="Previous Item"
        style={{ width: '3.66032%', top: '50%' }}
      >
        <img src={KalingoLeftArrow} style={{ height: '37px' }} alt="KalingoLeftArrow" />
      </button>
    )
  }

  function RightArrow() {
    const { isLastItemVisible, scrollNext } = React.useContext(VisibilityContext)
    return (
      <button
        className={`absolute right-0 z-10 bg-transparent px-0 hidden lg:flex justify-center ${
          isLastItemVisible ? 'opacity-0' : 'opacity-100'
        }`}
        disabled={isLastItemVisible}
        onClick={() => scrollNext()}
        title="Next Item"
        style={{ width: '3.66032%', top: '50%' }}
      >
        <img src={KalingoRightArrow} style={{ height: '37px' }} alt="KalingoLeftArrow" />
      </button>
    )
  }

  return (
    <div
      className={`w-full relative ${isEdit && hoverState && 'component-hover-class'}`}
      style={{
        backgroundColor: getStyleValue('component_background', 'primary_color', ''),
        padding: '0px 3.66032%',
      }}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onDelete={() => onDelete(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
          onEdit={() => handleModal()}
          onCopy={() => onCopy(id)}
        />
      )}
      <div className="py-[16px] lg:py-8">
        <h2
          style={{
            color: getStyleValue('heading', 'color', '#ffffff'),
          }}
          className={`xl:text-2xl md:text-xl text-xs mb-3 font-semibold`}
        >
          {data?.name}
        </h2>
        <div className="w-full text-[#fefefe]">
          <ScrollMenu
            LeftArrow={LeftArrow}
            RightArrow={RightArrow}
            wrapperClassName="w-full md:mt-4"
          >
            {data?.slide_data &&
              data?.slide_data.map((info, index) => (
                <Card
                  key={index}
                  itemId={`index${index}`}
                  index={index}
                  info={info}
                  handleRedirect={handleRedirect}
                  theme={theme}
                  cardStyle={{
                    background: getStyleValue('card_style', 'card_bg_color', '#ffffff'),
                  }}
                  headingStyle={{
                    color: getStyleValue('card_style', 'heading_color', '#05498d'),
                  }}
                  paragraphStyle={{
                    color: getStyleValue('card_style', 'paragraph_color', '#909090'),
                  }}
                  readMoreStyle={{
                    color: getStyleValue('card_style', 'read_more_color', '#05498d'),
                  }}
                  dateStyle={{
                    color: info?.date_text
                      ? getStyleValue('card_style', 'date_color', '#909090')
                      : getStyleValue('card_style', 'card_bg_color', '#ffffff'),
                  }}
                />
              ))}
          </ScrollMenu>
        </div>
      </div>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

function Card({
  index,
  info,
  handleRedirect,
  cardStyle,
  headingStyle,
  paragraphStyle,
  readMoreStyle,
  dateStyle,
}) {
  const { getTemplateImage } = useTemplateHook()
  return (
    <div
      key={index}
      className={`${
        index > 0 ? 'ml-3 xl:ml-[22px]' : ''
      } xl:w-[280px] lg:w-[250px] w-[230px] cursor-pointer rounded-lg overflow-hidden`}
      style={{
        position: 'relative',
        aspectRatio: '280/447',
        ...cardStyle,
      }}
      onClick={() => handleRedirect(info?.link)}
    >
      <div className="w-full">
        <CustomImage
          imageUrl={getTemplateImage(info?.image_s3key)}
          imgClass="z-0 w-full h-full"
          imgStyle={{ aspectRatio: '1.6568047337' }}
          loaderClass="z-0 w-full h-2/3"
          loaderStyle={{
            background: '#5A5A5A50',
            aspectRatio: '1.6568047337',
          }}
          imgAlt={'class img"'}
        />
      </div>
      <div
        style={{ aspectRatio: '280/278' }}
        className="pt-3 xl:pt-4 pb-2 xl:pb-3 flex flex-col justify-between w-full"
      >
        <div className="px-[12px] xl:px-5">
          <p
            className={`font-semibold  w-full xl:text-base text-sm line-clamp-5`}
            style={{ marginBottom: '0', lineHeight: '1.25', ...headingStyle }}
          >
            {info?.heading}
          </p>
          <p
            className={` w-full xl:text-[11px] text-[10px] mt-2 xl:mt-[10px] line-clamp-5`}
            style={{ marginBottom: '0', ...paragraphStyle }}
          >
            {info?.paragraph}
          </p>
        </div>
        <div>
          <p
            className={`px-[12px] xl:px-5 font-semibold  w-full xl:text-[11px] text-[10px] `}
            style={{ marginBottom: '0', ...readMoreStyle }}
          >
            {info?.read_more}
          </p>
          <p
            className={`px-[12px] xl:px-5 mt-1 xl:mt-[14.3px] w-full pt-1 xl:pt-2 text-[10px] `}
            style={{ marginBottom: '0', borderTop: '0.5px solid #d1d1d1', ...dateStyle }}
          >
            {info?.date_text ? info?.date_text : '.'}
          </p>
        </div>
      </div>
    </div>
  )
}

export default withTheme(BreakingInsightsCarousel)
